import { useBanner } from 'modules/common/hooks/useBanner'
import { EnumBannerKey } from 'modules/common/types/banner'

export const useEmergencyBanner = () => {
  const IS_EMERGENCY_BANNER_ENABLED = process.env
    .NEXT_PUBLIC_EMERGENCY_BANNER_ENABLED as string

  return useBanner({
    bannerKey: EnumBannerKey.EMERGENCY,
    displayCondition: IS_EMERGENCY_BANNER_ENABLED === 'true',
  })
}
